<div
  class="dashboard-reimbursement-summary"
  aria-labelledby="dashboard-reimbursement-summary-title">
  <mat-card-title id="dashboard-reimbursement-summary-title" class="dashboard-card-title">
    {{ 'dashboard.reimbursement_summary.title' | translate }}
  </mat-card-title>

  <div class="dashboard-reimbursement-summary__total-panel">
    <strong class="dashboard-reimbursement-summary__total-value">
      {{ totalReimbursement() | currency }}
    </strong>
    <span class="dashboard-reimbursement-summary__total-label">
      {{ 'dashboard.reimbursement_summary.totalLabel' | translate }}
    </span>
  </div>

  <div class="dashboard-reimbursement-summary__breakdown">
    <div class="dashboard-reimbursement-summary__breakdown-item dashboard-reimbursement-summary__breakdown-item--cash">
      <span class="dashboard-reimbursement-summary__breakdown-label">
        {{ 'dashboard.cash_reimbursement' | translate }}
      </span>
      <strong>{{ totalCashReimbursement() | currency }}</strong>
    </div>
    <div class="dashboard-reimbursement-summary__breakdown-item dashboard-reimbursement-summary__breakdown-item--inventory">
      <span class="dashboard-reimbursement-summary__breakdown-label">
        {{ 'dashboard.inventory_reimbursement' | translate }}
      </span>
      <strong>{{ totalInventoryReimbursement() | currency }}</strong>
    </div>
  </div>

  <button
    type="button"
    mat-stroked-button
    color="primary"
    class="dashboard-lost-claim-card__action"
    (click)="navigateToReimbursementsReport()">
    {{ 'dashboard.reimbursement_summary.viewReport' | translate }}
  </button>
</div>
